import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../../context/combinedContext";

const AccountHelpAndSupport = () => {
    const { language, userData } = useContext(CombinedContext);
    const navigate = useNavigate();
    const role = userData?.user?.role;
    const isOwner = role === "owner" || role === "admin";

    const items = [
        {
            id: "contact",
            label: language === "es" ? "Contacto" : "Contact",
            path: "/account/contact",
        },
        {
            id: "faq",
            label: "FAQ",
            comingSoon: true,
        },
        ...(isOwner ? [{
            id: "resources",
            label: language === "es" ? "Recursos para negocios" : "Business Resources",
            comingSoon: true,
        }] : []),
    ];

    return (
        <div className="account-menu">
            {items.map((item) => (
                <div
                    key={item.id}
                    className={`menu-item ${item.comingSoon ? "coming-soon" : ""}`}
                    onClick={() => {
                        if (item.comingSoon) return;
                        navigate(item.path);
                    }}
                >
                    <span>{item.label}</span>
                    {item.comingSoon && (
                        <span className="menu-coming-soon">
                            <span className="menu-coming-soon-sep">·</span>
                            {language === "es" ? "Próximamente" : "Coming soon"}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default AccountHelpAndSupport;